import * as React from 'react';

const AccountInfoIcon = ({fillColor = '#2D2756'}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={14} height={16}>
    <path
      fill={fillColor}
      d="M7.004 12.167a.61.61 0 0 0 .621-.625V8.625a.603.603 0 0 0-.18-.445.61.61 0 0 0-.449-.18.61.61 0 0 0-.621.625v2.917c0 .177.06.325.18.445.121.12.27.18.449.18Zm0-6.042c.178 0 .326-.06.444-.18a.615.615 0 0 0 .177-.449.615.615 0 0 0-.629-.621.615.615 0 0 0-.621.629c0 .178.06.326.18.444.121.118.27.177.449.177ZM1.584 15.5c-.344 0-.639-.122-.883-.367a1.204 1.204 0 0 1-.368-.883V6.125a1.241 1.241 0 0 1 .5-1L6.25 1.062c.218-.166.467-.25.747-.25.28 0 .53.084.753.25l5.417 4.063a1.242 1.242 0 0 1 .5 1v8.125c0 .344-.123.638-.367.883a1.204 1.204 0 0 1-.883.367H1.583Zm0-1.25h10.833V6.042L7 2.104 1.583 6.042v8.208Z"
    />
  </svg>
);

export default AccountInfoIcon;
